import React from 'react'
import classnames from 'classnames'

export const PartnershipsList = ({
  values = [],
  color1 = '#5F9941',
  color2 = '#5F9941'
}) => {

  const list = values.map((partnership, i) => {
    return (
      <div key={i} className="data-vis-box-container">
        <div className="stat-graph compareLineGraph compareCenter">
          <div className="bar-total">{partnership.total}</div>

          <div className="bar-col left">
            <div className="chartValue"><span className="name">{partnership.playerA.name}</span>
              <span className="value" dangerouslySetInnerHTML={{ __html: `${partnership.playerA.value}` }} />
            </div>
            <span className="bar-percentage" style={{ background: color1, width: `${partnership.playerA.runs || 0}%` }}/>
          </div>
          <div className="bar-col right">
            <span className="bar-percentage less" style={{ background: color2, width: `${partnership.playerB.runs || 0}%` }}/>
            <div className="chartValue">
              <span className="name">{partnership.playerB.name}</span>
              <span className="value" dangerouslySetInnerHTML={{ __html: `${partnership.playerB.value}` }}/>
            </div>
          </div>
        </div>
      </div>
    )
  })

  return (
    <div>
      {list}
    </div>
  )
}

/**
 * Used in partnerships module on statistics page.
 * Display partnership graphs in Innings buttons for limited over matches.
 * Display partnership graphs in Innings tabs for test matches.
 */
export class Partnerships extends React.Component {

  constructor(props) {
    super(props)
    this.state = { active: 0 }
  }

  switchTab(tab) {
    this.setState({
      active: tab
    })
  }

  render() {

    const { teams= {}, uiControls = {}, pshipByInnings = [] } = this.props
    const { active = 0 } = this.state
    const homeTeam = teams.home || {}
    const awayTeam = teams.away || {}
    const homeColor = homeTeam.color 
    const awayColor = awayTeam.color
    // dynamic class name based on format
    let statContainerClass = uiControls.showButtons ? '' : 'tab-pane'
    // Buttons appear for limited overs matches
    
    let teamByInnings = []

    if(homeTeam.order === 1) {
      teamByInnings.push(homeTeam, awayTeam)
    }else{
      teamByInnings.push(awayTeam, homeTeam)
    }

    let innButtons = (
      <div className="tabControls hidden-sm hidden-md hidden-lg">
        <div className="filter form-group button-group">
        {
          teamByInnings.map((t, i) => {
            return (
              <button key={i}
              onClick={this.switchTab.bind(this, i)}
              className={classnames('button-filter-alt lg fixed', { active: i == active })}>
              <span className="team-name">{t.abbrev || t.name}</span>
            </button>
            )
          })
        }
        </div>
      </div>
    )

    let innTabs = (
      <div className="tab-container">
        <ul className="tabs alt" data-behavior="tabs_transform">
        {
          pshipByInnings.map((inn, i) => {
            let title = inn.titles && inn.titles.brief
            return <li onClick={this.switchTab.bind(this, i)} key={i} className={ i == active ? 'active' : ''}><span>{title}</span></li>
          })
        }
        </ul>
      </div>
    )

    return (
      <article className="sub-module stats tabbedTable partnership-tabs" data-behavior="tabbedTable">
        <header className="bordered">
            <h1>Partnerships</h1>
        </header>

        {/* Start of partnerships content */}
        <div className="content">

          {/* Start of tab/buttons for innings */}
          { uiControls.showButtons ? innButtons : innTabs }
          {/* End of tab/buttons for innings */}

          {/* Start of content for tabs */}
          <div className="tab-content">
              {
                pshipByInnings.map((inning, i) => {
                  //console.info('i, active', i, active)
                  let color = inning.ha === 'home' ? homeColor : awayColor
                  return (
                    <div className={classnames('table-wrap stat-container partnerships', { active: i == active }, statContainerClass)}
                    key={i}>
                        <h3>{inning.titles.full}</h3>
                        <PartnershipsList color1={color} color2={color} values={inning.data} key={i} />
                    </div>
                  )
                })
              }

          </div>
          {/* End of content for tabs */}

        </div>
        {/* End of partnerships content */}
      </article>
    )
  }
}

export default Partnerships



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/Partnerships.jsx
 **/